import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, MapPin } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const blank = { name: "", tech_park: "", address: "", description: "", image_url: "", start_date: "", end_date: "", is_active: true };

export default function LocationsAdmin() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(blank);
  const [editId, setEditId] = useState(null);

  const load = () => api.get("/admin/locations").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editId) await api.put(`/admin/locations/${editId}`, form);
      else await api.post("/admin/locations", form);
      toast.success("Saved"); setOpen(false); setForm(blank); setEditId(null); load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const edit = (l) => { setForm(l); setEditId(l.id); setOpen(true); };
  const del = async (id) => { if (!window.confirm("Delete location?")) return; await api.delete(`/admin/locations/${id}`); load(); };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="font-display font-extrabold text-3xl">Locations</h1><p className="text-slate-400">Tech parks where the truck parks.</p></div>
        <Button data-testid="add-location-btn" onClick={() => { setForm(blank); setEditId(null); setOpen(true); }} className="bg-violet-600 hover:bg-violet-500"><Plus className="h-4 w-4 mr-1" /> New location</Button>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {rows.map((l) => (
          <div key={l.id} className="rounded-2xl border border-white/10 bg-[#131a29] p-4" data-testid={`admin-loc-${l.id}`}>
            <div className="flex items-center gap-2 text-violet-400 text-xs font-mono uppercase"><MapPin className="h-3.5 w-3.5" /> {l.tech_park}</div>
            <h3 className="font-display font-bold mt-1">{l.name}</h3>
            <p className="text-xs text-slate-400 mt-1">{l.address}</p>
            <div className="flex gap-2 mt-4">
              <Button size="sm" variant="secondary" onClick={() => edit(l)} data-testid={`edit-loc-${l.id}`}><Pencil className="h-3.5 w-3.5" /></Button>
              <Button size="sm" variant="ghost" className="text-red-400" onClick={() => del(l.id)} data-testid={`del-loc-${l.id}`}><Trash2 className="h-3.5 w-3.5" /></Button>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#131a29] border-white/10">
          <DialogHeader><DialogTitle>{editId ? "Edit" : "New"} location</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <Input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="loc-name" className="bg-slate-950/50 border-white/10" />
            <Input placeholder="Tech park / area" value={form.tech_park} onChange={(e) => setForm({ ...form, tech_park: e.target.value })} className="bg-slate-950/50 border-white/10" />
            <Input placeholder="Address" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className="bg-slate-950/50 border-white/10" />
            <Textarea placeholder="Description (gate, landmark)" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="bg-slate-950/50 border-white/10" />
            <Input placeholder="Image URL" value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} className="bg-slate-950/50 border-white/10" />
          </div>
          <DialogFooter><Button onClick={save} data-testid="save-loc" className="bg-violet-600 hover:bg-violet-500">Save</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
